/**
 * Chipy filtrow + select sklepu (wg adresu dostawy z SFD) + "szukaj po numerze".
 *
 * Zaznaczony chip = PELNE tlo + kolor #fff ustawione INLINE - motyw wymusza
 * !important na przyciskach, a wyjatek :not([style*="background"]) w
 * v3sys-theme.css dziala tylko dla inline background. Nie zamieniac na klasy.
 */
import React from 'react';
import { FILTRY, NIEZNANY_ADRES, SKLEP_NIEZNANY_ID } from './format';

const WSZYSTKIE = '';

const FiltryKontroli = ({ filtr, onFiltr, szukaj, onSzukaj, liczby, perSklep, sklepId, onSklep, bezUfr = true, onBezUfr, wykluczoneUfr }) => {
  const l = liczby || {};
  const sklepy = Array.isArray(perSklep) ? perSklep : [];
  const znane = sklepy.filter(s => s.sklep_id !== null && s.sklep_id !== undefined);
  const nieznane = sklepy.filter(s => s.sklep_id === null || s.sklep_id === undefined);
  const nieznanychDok = nieznane.reduce((a, s) => a + (s.w_portalu || 0), 0);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
      <div role="group" aria-label="Filtr" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {FILTRY.map(f => {
          const aktywny = f.id === filtr;
          const licznik = f.licznik && l[f.licznik] !== undefined && l[f.licznik] !== null ? ` (${l[f.licznik]})` : '';
          return (
            <button
              key={f.id}
              type="button"
              data-testid={`filtr-${f.id}`}
              aria-pressed={aktywny}
              onClick={() => onFiltr(f.id)}
              style={{
                padding: '4px 10px', fontSize: '11px', fontWeight: 600, borderRadius: '12px', cursor: 'pointer',
                border: `1px solid ${f.kolor}`,
                background: aktywny ? f.kolor : 'var(--card-bg)',
                color: aktywny ? '#fff' : f.kolor,
              }}
            >
              {f.etykieta}{licznik}
            </button>
          );
        })}
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', alignItems: 'center' }}>
        {onSklep && (
          <label style={{ fontSize: '11px', color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
            Sklep{' '}
            <select
              aria-label="Sklep"
              data-testid="filtr-sklep"
              value={sklepId === null || sklepId === undefined ? WSZYSTKIE : String(sklepId)}
              onChange={(e) => onSklep(e.target.value === WSZYSTKIE ? null : Number(e.target.value))}
              style={{
                padding: '4px 8px', fontSize: '11px', borderRadius: '4px', border: '1px solid var(--border)',
                backgroundColor: 'var(--card-bg)', color: sklepId === SKLEP_NIEZNANY_ID ? 'var(--warning)' : 'var(--text)',
              }}
            >
              <option value={WSZYSTKIE}>wszystkie sklepy</option>
              {znane.map(s => (
                <option key={s.sklep_id} value={String(s.sklep_id)}>{s.nazwa}{s.w_portalu !== undefined ? ` (${s.w_portalu})` : ''}</option>
              ))}
              {nieznane.length > 0 && (
                <option value={String(SKLEP_NIEZNANY_ID)}>{NIEZNANY_ADRES} ({nieznanychDok})</option>
              )}
            </select>
          </label>
        )}
        {/* Faktury kosztowe (seria UFR) - domyslnie poza kontrola; odznacz, zeby je porownywac */}
      <label
        title="Seria UFR to faktury kosztowe, nie towarowe. Zaznaczone = poza kontrolą."
        style={{
          display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', whiteSpace: 'nowrap',
          padding: '4px 10px', border: '1px solid var(--border)', borderRadius: '6px',
          backgroundColor: bezUfr ? 'var(--card-bg)' : 'var(--warning-light)',
          color: bezUfr ? 'var(--text)' : 'var(--warning)'
        }}>
        <input type="checkbox" checked={!!bezUfr} onChange={(e) => onBezUfr && onBezUfr(e.target.checked)} style={{ width: '14px', height: '14px', cursor: 'pointer' }} />
        Bez faktur kosztowych (UFR){bezUfr && wykluczoneUfr ? ` — pominięto ${wykluczoneUfr}` : ''}
      </label>
      <input
          type="search"
          value={szukaj}
          onChange={(e) => onSzukaj(e.target.value)}
          placeholder="Szukaj po numerze…"
          aria-label="Szukaj po numerze"
          style={{
            padding: '4px 8px', fontSize: '11px', borderRadius: '4px', minWidth: '220px',
            border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', color: 'var(--text)',
          }}
        />
      </div>
    </div>
  );
};

export default FiltryKontroli;
